import { OptionsProps, ContextProvider } from './context';
import { MemoVideoPlayer, VideoPlayerProps } from './VideoPlayer';

type VideoPlayerMode =
    | {
          mode: 'autoplay';
          currentFrame?: number;
      }
    | {
          mode: 'scrub';
          currentFrame: number;
          loop?: boolean;
      };

type VideoGridProps = VideoPlayerMode & VideoPlayerProps & Omit<OptionsProps, 'videoCount'>;

export const VideoGrid = ({ currentFrame = 0, columns, showSkeleton, ...props }: VideoGridProps) => {
    return (
        <ContextProvider columns={columns} showSkeleton={showSkeleton} videoCount={props.videos.length}>
            <MemoVideoPlayer {...props} />
        </ContextProvider>
    );
};
